import { render, staticRenderFns } from "./design_scaler.vue.js?vue&type=template&id=7fb84f4c!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_scaler.vue?vue&type=template&id=7fb84f4c"
import script from "./design_scaler.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_scaler.vue?vue&type=script&lang=js"
export * from "./design_scaler.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_scaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports